import React, { Component } from 'react'

import './styles.scss'
import Checkbox from '../Checkbox'
import PropTypes from 'prop-types'

class BoxedCheckbox extends Component {
  render () {
    let label
    if (this.props.label !== undefined) {
      label = this.props.label
    }
    return (
      <div className={'boxedCheckbox'}>
        {this.props.invert !== true ?
          <div className={'bcLabelContainer'}>{label}</div>
        : null}
        <div className="boxedCheckboxInput">
          {this.props.invert !== true ? this.props.checkboxPrepend : null}
          <Checkbox disabled={this.props.disabled} classNames={this.props.checkboxClassNames} onChange={this.props.onChange} value={this.props.value}/>
          {this.props.invert === true ? this.props.checkboxPrepend : null}
        </div>
        {this.props.invert === true ?
          <div className={'bcLabelContainer bcLabelContainerInverted'}>{label}</div>
          : null}
      </div>
    )
  }
}

BoxedCheckbox.defaultProps = {
  label: null,
  invert: false
}

BoxedCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  checkboxPrepend: PropTypes.any,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string,PropTypes.element]),
  checkboxClassNames: PropTypes.string,
  invert: PropTypes.bool
}

export default BoxedCheckbox
